<template>
    <EditingDialog
        :context="context"
        :useDifferentShowDialogProp="true"
        :useDifferentSaveFunction="true"
        :differentSaveFunction="saveFunction"
        maxCardHeight="900"
    >
    <!-- :addAtTop="true" -->
        <template v-slot:editForm>           
            <v-row>
                <!-- Interested Party -->
                <v-col cols="6">
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="InterestedParty"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_INTERESTED_PARTY')"
                        rules="required"
                        :withFreeText="false"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-autocomplete-interested-party-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-interested-party-selection'">
                                <template v-if="isPublisherRole">
                                    {{ item.group || item.gemaName }}
                                </template>
                                <template v-else>
                                    {{ item.gemaName }}
                                    <span v-if="$alvPlugin.printName(item)">
                                        ({{ item.firstName }} {{ item.lastName }})
                                    </span>
                                </template>
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-interested-party-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-interested-party-dropdown-' + items.alvId + '-title'">
                                    <template v-if="isPublisherRole">
                                        {{ items.group || items.gemaName }}
                                    </template>
                                    <template v-else>
                                        {{ items.gemaName }}
                                        {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}}
                                    </template>
                                    <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-interested-party-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== '' ? items.ipi : $t('lang_GENERIC_CAPTION_NONE') }} | {{ items.alvId }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-col>
                <v-col cols="6">
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Pwr"
                        :items="interestedPartiesItems"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_UVZ')"
                        :selection="true"
                        :multiple="true"
                        :withMargin="false"
                        itemText="name"
                        itemValue="id"
                        :returnObject="true"
                        :alvqa="alvqa + '-dropdown-uvz'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <!-- Role -->
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Role"
                        :items="roleItems" 
                        :label="$t('lang_LABEL_TRACKS_CAPTION_ROLE')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-type'"
                    />
                </v-col>
                <!-- PMR -->
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Pmr"
                        :items="zbsItems"
                        :label="$t('lang_GENERAL_PMR')"
                        :selection="true"
                        :multiple="false"
                        :withMargin="false"
                        itemText="name"
                        itemValue="id"
                        :returnObject="true"
                        :alvqa="alvqa + '-dropdown-pmr'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <!-- Society Pr -->
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="PrSociety"
                        :items="societyItems"
                        :label="$t('lang_GENERIC_CAPTION_SOCIETY_PR')"
                        :selection="true"
                        :withMargin="false"
                        :alvqa="alvqa + '-dropdown-society-pr'"
                    />
                </v-col>
                <!-- Society Mr -->
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="MrSociety"
                        :items="societyItems"
                        :label="$t('lang_GENERIC_CAPTION_SOCIETY_MR')"
                        :selection="true"
                        :withMargin="false"
                        :alvqa="alvqa + '-dropdown-society-mr'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <!-- PR PERCENT -->
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="PrPercent"
                        :label="getCaptionPercent('pr')"
                        :withMargin="false"
                        rules="percentDecimal"
                        :disabled="showManuFields"
                        :alvqa="alvqa + '-textfield-manu-percent-pr'"
                    />
                </v-col>
                <!-- MR PERCENT -->
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="MrPercent"
                        :label="getCaptionPercent('mr')"
                        :withMargin="false"
                        rules="percentDecimal"
                        :disabled="showManuFields"
                        :alvqa="alvqa + '-textfield-manu-percent-mr'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

import { DropdownGenericInterestedPartyRoles } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "OriginalSharesEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageAutocomplete,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "WorksOriginalShares",
            alvqa: "publishing-works-edit-form-original-shares-panel-editing-dialog",
            _shareType: ""
        }
    },
    computed: {
        isPublisherRole() {
            const role = this.$store.getters.getWorksOriginalSharesDetailsRole
            return ['E', 'SE'].includes(role)
        },
        getOriginalShares() {
            return JSON.parse(JSON.stringify(this.$store.getters.getWorksOriginalShares))
        },
        getShareType() {
            return this.$store.getters.getWorksOriginalSharesDetailsShareType
        },
        getSelectedItem() {
            return this.$store.getters.getSelectedWorksOriginalShares
        },
        zbsItems(){
            let zbsItems = []
            if (this.getShareType == null) return zbsItems

            let originalShares = this.getOriginalShares[this.getShareType]
            let selectedPwrArray = this.$store.getters.getWorksOriginalSharesDetailsPwr
            originalShares.forEach(share => {
                let match = selectedPwrArray.find( pwrItem => {
                    return pwrItem.id === share.id
                });

                if(!match){
                    return
                }else{
                    zbsItems.push({
                        role: share.role,
                        position: share.position,
                        id: share.id,
                        name: share.name + ' (' + share.role + share.position + ')'
                    }) 
                }
            })
            return zbsItems    
        },
        roleItems() {
            let dropdownItems = DropdownGenericInterestedPartyRoles.filter((val) => {
                // Remove E and SE if shareType is manu 
                if (this.getShareType == "manu")
                    return !['E', 'SE'].includes(val.text)
                return true
            }) 
            return dropdownItems.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0) 
        },
        interestedPartiesItems() {
            const shareType = this.getShareType
            let interestedPartiesItems = []
            if (shareType == null) return interestedPartiesItems;
            let originalSharesList = [...this.getOriginalShares[shareType]] // Get copy of list
            
            if(originalSharesList.length === 0) { return interestedPartiesItems }
            else {
                // delete selected row from the possible options, 
                //row can not refer to itself in the uvz dropdown
                let selectedRow = this.getSelectedItem
                if(selectedRow.length !== 0) {
                    let indexOfItem = originalSharesList.findIndex(share => share.id === selectedRow)
                    originalSharesList.splice(indexOfItem, 1) 
                }

                // find the original share rows with role E or SE for uvz and pmr dropdown
                originalSharesList.forEach(share => {
                    if(share.role === 'E' || share.role === 'SE') {
                        interestedPartiesItems.push({
                            role: share.role,
                            position: share.position,
                            id: share.id,
                            name: share.name + ' (' + share.role + share.position + ')'
                        })
                    }
                })
            }
            return interestedPartiesItems
        },
        societyItems() { 
            let societies = this.$store.getters.getSocieties

            // setting alvqa for GI Tests and reformatting to change society codes in dropdown
            societies.forEach(society => { society['alvqa'] = this.alvqa + '-dropdown-recipient-' + society.value })
            
            // sorting with js before 
            societies.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)
            return societies
         },
         showManuFields() {
             let selectedRole = this.$store.getters.getWorksOriginalSharesDetailsRole
             if (this.getShareType == 'manu' && 
                (selectedRole == 'E' || selectedRole == 'SE')
                )
                return true // disabled and not editable
            else
                return false
         },
    },

    methods: {
        saveFunction() {
            const shareType = this.getShareType
            if (shareType == null) return

            let listItems = this.getOriginalShares
            let editedItem = this.$store.getters.getWorksOriginalSharesEditingDialogDetails

            let selectedItem = this.getSelectedItem
            let isNew = selectedItem.length === 0 
            
            // save process is different depending on if the user is editing an existing item or adding a new one.
            if(isNew) {
                editedItem.id = -(Math.floor(Math.random() * 10000))
                
                listItems[shareType].unshift(editedItem)
                this.$store.commit('setWorksOriginalShares', listItems)
            } else {
                let index
                index = listItems[shareType].findIndex(element => {
                            return element.id === selectedItem
                        })

                Object.assign(listItems[shareType][index], editedItem)
            } 
            this.$store.dispatch('addWorksOriginalShares')
        },
        getCaptionPercent(type) {
            const shareTypeTranslations = [
                {text: this.$t('lang_GENERIC_CAPTION_MANU_PERCENT'), value: "manu"},
                {text: this.$t('lang_GENERIC_CAPTION_ROLE_PERCENT'), value: "role"},
                {text: this.$t('lang_GENERIC_CAPTION_INTL_PERCENT'), value: "intl"},
                {text: this.$t('lang_GENERIC_CAPTION_OWN_PERCENT'), value: "own"},
            ]

            const rightsTypeTranslations = [
                {text: this.$t('lang_PUBLISHING_CAPTION_PERFORMING_RIGHTS_ABBREVIATION'), value: "pr"},
                {text: this.$t('lang_PUBLISHING_CAPTION_MECHANICAL_RIGHTS_ABBREVIATION'), value: "mr"},
            ]
            
            let captionShareType = shareTypeTranslations.find((el) => el.value === this.getShareType)
            captionShareType = captionShareType ? captionShareType.text : ""
            let captionsRightsType = rightsTypeTranslations.find((el) => el.value === type)
            captionsRightsType = captionsRightsType ? captionsRightsType.text : ""

            return `${captionShareType} ${captionsRightsType}`
        }
    },

    created() {
        this.$store.commit('setSocieties')
    }
}
</script>